module.exports = __webpack_public_path__ + "static/media/aldrin.07ad788d.jpg";